// extracted by mini-css-extract-plugin
module.exports = {"timer":"styles_timer__f-aui","timeBlocks":"styles_timeBlocks__JvTse","label":"styles_label__2Z_kC","timerInline":"styles_timerInline__3ifH-","time":"styles_time__3NZSb"};